import React from 'react';  // eslint-disable-line

const Text = (props) => {
    return (
        <svg width="79px" height="33px" viewBox="0 0 79 33" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Admin-CMS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="custom-content-video-2" transform="translate(-370.000000, -433.000000)">
                    <g id="Group-2" transform="translate(370.000000, 433.000000)">
                        <rect id="Rectangle-Copy-4" fill={props.active ? '#176BFB' : '#616B7D'} x="0" y="8.8817842e-16" width="79" height="10" />
                        <rect id="Rectangle-Copy-8" fill={props.active ? '#5C97FC' : '#B2B7BF'} x="0" y="14" width="74" height="5" />
                        <rect id="Rectangle-Copy-9" fill={props.active ? '#5C97FC' : '#B2B7BF'} x="0" y="21" width="60" height="5" />
                        <rect id="Rectangle-Copy-10" fill={props.active ? '#5C97FC' : '#B2B7BF'} x="0" y="28" width="78" height="5" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Text;
